window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
window.moment = require('./../../node_modules/moment/min/moment.min')

/** modal **/
window.Modal = require('bootstrap/js/dist/modal');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/collapse');

try {
    require('startbootstrap-sb-admin/src/js/scripts');
} catch (e) {}

export function sidebarListener() {
    require('startbootstrap-sb-admin/src/js/scripts');
}

sidebarListener();

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

require('./plugin/linesTable.src')
require('./plugin/signaturePad.src')
require('./plugin/multipleEmails.src')
require('./plugin/addEmailRecipients.src')
require('./plugin/uploadFile.src')
require('./../../node_modules/datatables.net/js/jquery.dataTables')
require('./../../node_modules/datatables.net-plugins/dataRender/datetime')
require('./../../node_modules/datatables.net-select/js/dataTables.select')
require('./../../node_modules/jq-signature/jq-signature')
require('./../../node_modules/blueimp-file-upload/js/jquery.fileupload.js');

// QuillJS
window.Quill = require('./../../node_modules/quilljs-cdn/1.3.6/quill')
